import { render, staticRenderFns } from "./enclosureModel案例.vue?vue&type=template&id=fb17c242&scoped=true"
import script from "./enclosureModel案例.vue?vue&type=script&lang=js"
export * from "./enclosureModel案例.vue?vue&type=script&lang=js"
import style0 from "./enclosureModel案例.vue?vue&type=style&index=0&id=fb17c242&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb17c242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb17c242')) {
      api.createRecord('fb17c242', component.options)
    } else {
      api.reload('fb17c242', component.options)
    }
    module.hot.accept("./enclosureModel案例.vue?vue&type=template&id=fb17c242&scoped=true", function () {
      api.rerender('fb17c242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionnaire/customerManage/questionnaireList/components/enclosureModel案例.vue"
export default component.exports